import React, { useState } from "react";
import '../assets/scss/custom/multiselectDropdown.scss'
type DropdownValue={
    id:string,
    name: string
}

interface MultiselectDropdownProps{
    selectedValues:object;
    allValues:DropdownValue[];
    callback:(payload:any)=>void;
    required?:boolean
    defaultValue:string
}

const MultiSelectDropdown = (props:MultiselectDropdownProps) => {
    const [open, setOpen] = useState<boolean>(false);
    return(
        <div className="position-relative" >
            <select 
            onClick={()=>setOpen(!open)}
            onMouseDown={(e)=>e.preventDefault()}
            className={`form-select form-select-sm`}
            required={props.required}
            >
            <option value={Object.keys(props.selectedValues).length || ""}>{props.defaultValue}</option>
            </select>
            {open && props.allValues.length>0 && (
            <div className="multiselect-dropdown">
                {props.allValues.map((opt:DropdownValue) => {
                return(
                <div key={opt.id} className="multiselect-dropdown-item">
                    <input
                    className="form-check-input m-1"
                    type="checkbox"
                    id={opt.id} 
                    checked={Object.keys(props.selectedValues)?.includes(opt.id)}
                    onChange={() => props.callback(opt)}
                    />
                    <label className="pl-1 fs-12" htmlFor={opt.id}>
                    {opt.name}
                    </label>
                </div>
                )})}
            </div>
            )}
        </div>
    )
}

export default MultiSelectDropdown